import { atom, useAtom } from 'jotai';

// TYPES
import { User } from 'protectedRoute';

const currentUserAtom = atom<User | null>(null);

export const useCurrentUserAtom = () => useAtom(currentUserAtom);
